import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable, Subject } from 'rxjs';
import { ProductService } from './product.service';
import { Router } from '@angular/router';
import { CommanpageService } from './commanpages.service';
import { BrowserService } from 'src/_lib/service/browser.service';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root',
})
export class CommunicationService {
  showPlaceYourOrderButton: EventEmitter<boolean> = new EventEmitter<boolean>();
  clearVehicle: EventEmitter<boolean> = new EventEmitter<boolean>();
  onClickUseAddress: EventEmitter<boolean> = new EventEmitter<boolean>();
  onClickShipping: EventEmitter<boolean> = new EventEmitter<boolean>();
  onClickPayment: EventEmitter<boolean> = new EventEmitter<boolean>();
  chTheme1: boolean = environment.chTheme1;
  searchByPartNameProductKeyChange: Subject<null> = new Subject<null>();
  serchByPartHashKeyChange: Subject<null> = new Subject<null>();
  categoryKeyChange: Subject<null> = new Subject<null>();
  itemCount: Subject<null> = new Subject<null>();

  // Wishlist count
  wishlistCount: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  dealerChangeEffectSub: Subject<boolean> = new Subject<boolean>();

  addToCartService$ = new Subject<any>();
  private addItemToCartSubject = new BehaviorSubject<string[]>([]);
  serviceAddItemToCart$ = this.addItemToCartSubject.asObservable();

  // Cart login popup
  closedDialog$ = new Subject<any>();

  //shop-by-vehicle
  showVehicleButton: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  vehicleSearch_without_category: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  // product-page-maintain-color-size-state
  slugNotify: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  // fitment-data
  fitmentNotify: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  //inventory-disabled
    inventoryDisabled: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  //Cache-clear
  cacheClear: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  // customer-login corporate user dropdown
  private isCorporateUser = new BehaviorSubject<boolean>(
    this.browser.localStorage?.getItem('isCorporateUser') === 'true'
  );
  isCorporateUser$ = this.isCorporateUser.asObservable();

  private dropdownData = new BehaviorSubject<any[]>(
    JSON.parse(this.browser.localStorage?.getItem('dropdownData') || '[]')
  );
  dropdownData$ = this.dropdownData.asObservable();

  private dealerLocationSource = new BehaviorSubject<any>(null);
  dealerLocation$ = this.dealerLocationSource.asObservable();

  // Cart-application communication
  orderIDGenerateEmitter: EventEmitter<null> = new EventEmitter<null>();

  // Product-Details username
  usernameSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  usernameObservable: Observable<boolean> = this.usernameSubject.asObservable();

  // Username details (header)
  userNameValueSubject: BehaviorSubject<string | null> =
    new BehaviorSubject<string | null>(null);
  userNameValueObservable: Observable<string | null> =
    this.userNameValueSubject.asObservable();

  // Realtime vehicle data
  vehiclenameSubject: BehaviorSubject<string> =
    new BehaviorSubject<string>(this.browser.localStorage?.getItem('vehiclename') || ''); 

  vehicleFormSubject: BehaviorSubject<any> =
    new BehaviorSubject<any>(JSON.parse(this.browser.localStorage?.getItem('vehiclesearchForm') || 'null'));

  clearvehicle: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  // Cart-promotion response
  private cartDataSubject = new BehaviorSubject<any>(null);
  cartData$ = this.cartDataSubject.asObservable();

  // Save for later
  private saveForLaterSource = new Subject<any>();
  saveForLater$ = this.saveForLaterSource.asObservable();

  // Loader
  private loaderSubject = new BehaviorSubject<boolean>(false);
  loaderState$ = this.loaderSubject.asObservable();

  private verifyCartOnAddress = new Subject<any>();
  verifyCheckout$ = this.verifyCartOnAddress.asObservable();

  private doNotChangeTotalValue = new Subject<any>();
  doNotChangeTotalValue$ = this.doNotChangeTotalValue.asObservable();

  private paymentMethodSetting = new BehaviorSubject<any>(null);
  paymentMethodSetting$ = this.paymentMethodSetting.asObservable();

  // Product-may-you-like
  private productsSubject = new BehaviorSubject<any[]>([]);
  products$ = this.productsSubject.asObservable();

  private productAddedSource = new BehaviorSubject<any>(null);
  productAdded$ = this.productAddedSource.asObservable();

  private productRemovedSource = new BehaviorSubject<any>(null);
  productRemoved$ = this.productRemovedSource.asObservable();

  // Cart-promotion products
  private productSubject = new BehaviorSubject<any[]>([]);
  product$ = this.productSubject.asObservable();

  private productAddSource = new BehaviorSubject<any>(null);
  productAdd$ = this.productAddSource.asObservable();

  private productRemoveSource = new BehaviorSubject<any>(null);
  productRemove$ = this.productRemoveSource.asObservable();

  private categoryData = new BehaviorSubject<any>(null);
  categoryData$ = this.categoryData.asObservable();

  private topsellingData = new BehaviorSubject<any>(null);
  topsellingData$ = this.topsellingData.asObservable();

  private messageSource = new BehaviorSubject<string>('Thank you for your submission!');
  currentMessage = this.messageSource.asObservable();

  orderCustomerData$ = new BehaviorSubject<{ customer: any; billing: any; items?: any[] } | null>(null);

  setOrderCustomerData(customer: any, billing: any, items?: any[]) {
    this.orderCustomerData$.next({ customer, billing, items });
  }

  clearOrderCustomerData() {
    this.orderCustomerData$.next(null);
  }

  constructor(private productService: ProductService, private router: Router, private commonService: CommanpageService,  private browser: BrowserService ) { if (this.browser.isBrowser) {
    this.showVehicleButton.next(
      this.browser.localStorage?.getItem('searchByVehicleDisabled') || false
    );

    this.vehicleSearch_without_category.next(
      this.browser.localStorage?.getItem('vehicleSearch_without_category') || false
    );

    this.isCorporateUser.next(
      this.browser.localStorage?.getItem('isCorporateUser') === 'true'
    );

    this.dropdownData.next(
      JSON.parse(this.browser.localStorage?.getItem('dropdownData') || '[]')
    );

    this.vehiclenameSubject.next(
      this.browser.localStorage?.getItem('vehiclename') || ''
    );

    this.vehicleFormSubject.next(
      JSON.parse(this.browser.localStorage?.getItem('vehiclesearchForm') || 'null')
    );

    this._username.next(
      this.browser.localStorage?.getItem('Username')
    );
  } }

  updateMessage(message: string) {
    this.messageSource.next(message);
  }

  // Wishlist count
  setCount(count: number) {
    this.wishlistCount.next(count);
  }

  setCategoryData(data: any) {
    this.categoryData.next(data);
  }

  setTopSellingData(data: any) {
    this.topsellingData.next(data);
  }

  serviceAddItemToCart(selectedProduct: string[]) {
    this.addItemToCartSubject.next(selectedProduct);
  }

  setIsCorporateUser(value: boolean): void {
    this.browser.localStorage?.setItem('isCorporateUser', value.toString());
    this.isCorporateUser.next(value);
  }

  setDropdownData(data: any[]): void {
    this.browser.localStorage?.setItem('dropdownData', JSON.stringify(data));
    this.dropdownData.next(data);
  }

  sendDealerLocation(location: any) {
    this.dealerLocationSource.next(location);
  }

  setCartData(data: any) {
    this.cartDataSubject.next(data);
  }

  notifySaveForLater(item: any) {
    this.saveForLaterSource.next(item);
  }

  showLoader() {
    this.loaderSubject.next(true);
  }

  hideLoader() {
    this.loaderSubject.next(false);
  }

  notifyVerifyCart(item: any) {
    this.verifyCartOnAddress.next(item);
  }

  doNotChangeTotal(item: any) {
    this.doNotChangeTotalValue.next(item);
  }

  paymentMethodSettings(item: any) {
    this.paymentMethodSetting.next(item);
  }

  updateProducts(products: any[]) {
    this.productsSubject.next(products);
  }

  addProductToCart(productVariationKey: number) {
    this.productAddedSource.next(productVariationKey);
  }

  removeUpshellsProductFromCart(productVariationKey: number) {
    this.productRemovedSource.next(productVariationKey);
  }

  updateProducted(products: any[]) {
    this.productSubject.next(products);
  }

  addedProductInCart(productVariationKey: number) {
    this.productAddSource.next(productVariationKey);
  }

  removeCartPromotionProductFromCart(productVariationKey: number) {
    this.productRemoveSource.next(productVariationKey);
  }

  dealerChangeEffect() {
    this.dealerChangeEffectSub.next(true);
  }

  async dealerChange() {
    this.dealerChangeEffectSub.subscribe({
      next: async (value) => {
        if (value) {
          this.productService.initializeAllProductDetailsInfoOfApplication();
          this.productService.initializeMasterProductsDetails();
        }
      },
    });
  }

  private removeItemsSubject = new Subject<void>();
  removeItems$ = this.removeItemsSubject.asObservable();

  triggerRemoveItems() {
    this.removeItemsSubject.next();
  }

  private _username = new BehaviorSubject<string | null>(
    this.browser.localStorage?.getItem('Username')
  );
  username$ = this._username.asObservable();

  setUsername(name: string | null) {
    if (name) {
      this.browser.localStorage?.setItem('Username', name);
    } else {
      this.browser.localStorage?.removeItem('Username');
    }
    this._username.next(name);
  }

  // Place your order → payment popup
  openPlaceOrderPopup = new Subject<string>();
  private triggerPaymentSource = new Subject<void>();
  triggerPayment$ = this.triggerPaymentSource.asObservable();

  openPaymentPopup() {
    this.triggerPaymentSource.next();
  }

  cartItemRemoved$ = new Subject<boolean>();
  emitCartItemRemoved(flag: boolean) {
    this.cartItemRemoved$.next(flag);
  }

  openCheckoutLoginPopup$ = new Subject<void>();
  triggerCheckoutLoginPopup() {
    this.openCheckoutLoginPopup$.next();
  }

  setVehicleName(name: string) {
    if (name) {
      this.browser.localStorage?.setItem('vehiclename', name);
    } else {
      this.browser.localStorage?.removeItem('vehiclename');
    }
    this.vehiclenameSubject.next(name);
    if (name == '') {
    if (this.chTheme1) {
      this.router.navigate(['/parts-and-accessories']);
      return;
    }
      const currentUrl = this.router.url;
      const url = this.browser.window?.location.href;
      const parts = url.split('/');
      if (parts[4] && parts[4].startsWith('p')) {
        const product_key = this.browser.localStorage?.getItem('selectedproductkey');
        let product_name = this.browser.localStorage?.getItem('selectedProductName');
        product_name = this.commonService
          .setUrlNameField(product_name)
          .toLowerCase();
        this.router.navigate([`/${product_name}/p${product_key}`]);
      } else if (currentUrl.startsWith('/vehicle-search')) {
        this.router.navigate(['/']);
      } else {
        const prevReuse = this.router.routeReuseStrategy.shouldReuseRoute;
        const prevSameUrl = this.router.onSameUrlNavigation;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigateByUrl(currentUrl).finally(() => {
          this.router.routeReuseStrategy.shouldReuseRoute = prevReuse;
          this.router.onSameUrlNavigation = prevSameUrl;
        });
      }
    }
  }
  
  setVehicleForm(form: any) {
    if (form) {
      this.browser.localStorage?.setItem('vehiclesearchForm', JSON.stringify(form));
    } else {
      this.browser.localStorage?.removeItem('vehiclesearchForm');
    }
    this.vehicleFormSubject.next(form);
  }

  clearVehicleData() {
    this.setVehicleName('');
    this.setVehicleForm(null);
    this.clearVehicle.emit(true);
  }
}